import { forwardRef } from 'react'

const Textarea = forwardRef(function Textarea(
  {
    label,
    error,
    className = '',
    rows = 3,
    ...props
  },
  ref
) {
  const id = props.id || props.name

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={id}
        rows={rows}
        className={`form-input ${error ? 'has-error' : ''}`}
        style={{ resize: 'vertical' }}
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  )
})

export default Textarea
